import React, { useEffect, useRef } from "react"
import _ from "underscore";
import { flatNodes } from "../../model/nodes";
import M from "../../strings";
import { optional } from "../../utils/lang";

function getChildren(node, property) {
    if (!property) {
        property = "children";
    }

    if (node) {
        return node[property];
    }

    return null;
}

const Leaf = props => {
    const idSupplier = props.idSupplier ?? (n => n.id);
    const labelSupplier = props.labelSupplier ?? (n => n.description);
    const id = idSupplier(props.node, props.level);
    const label = labelSupplier(props.node, props.level);
    const branch = (getChildren(props.node, props.childrenProperty)) ? (
        <Branch 
            nodes={props.node.children} 
            onSelect={props.onSelect}
            onDeselect={props.onDeselect}
            selectedNodes={props.selectedNodes} 
            level={props.level + 1} 
            idSupplier={props.idSupplier}
            labelSupplier={props.labelSupplier}
            disableSelection={props.disableSelection}
            showInput={props.showInput}
            inputType={props.inputType}
            inputValues={props.inputValues}
            onInputChange={props.onInputChange}
            disableToggling={props.disableToggling}
            inputOnlyOnLeafs={props.inputOnlyOnLeafs}
            />
        ) : null;

    function onChange(e) {
        if (e.target.checked) {
            if (_.isFunction(props.onSelect)) {
                props.onSelect(props.node);
            }
        } else {
            if (_.isFunction(props.onDeselect)) {
                props.onDeselect(props.node);
            }
        }

        e.stopPropagation();
    }

    function count(node) {
        var flat = flatNodes(node, "children", false);
        return flat.length;
    }

    function countSelected(node) {
        var flat = flatNodes(node, "children", false);
        return flat.filter(n => props.selectedNodes?.some(sn => sn == idSupplier(n)) ?? false).length;
    }

    function onToggle(e) {
        optional(() => e.preventDefault());
        optional(() => e.stopPropagation());

        if (props.disableToggling) {
            return;
        }


        function findParentLeaf(element) {
            if ($(element).hasClass("tree-selector__leaf")) {
                return element;
            } else if (element.parentElement) {
                return findParentLeaf(element.parentElement);
            }

            return null;
        }
        const parent = findParentLeaf(e.target)
        const branch = $(parent).find(">.tree-selector__branch");
        const hidden = branch.data("hidden");
        if (hidden) {
            $(parent).removeClass("hidden");
            branch.slideDown().data("hidden", false);
        } else {
            branch.slideUp().data("hidden", true);
            $(parent).addClass("hidden");
        }
    }

    function onInputChange(e) {
        if (_.isFunction(props.onInputChange)) {
            props.onInputChange(id, e.target.value);
        }
    }

    function getInputValue() {
        if (props.inputValues) {
            return props.inputValues[id];
        }

        return null;
    }

    var numberOfSelectedNodes = countSelected(props.node);
    const numberOfNodes = count(props.node);

    return (
        <div className="tree-selector__leaf" data-level={props.level}>
            <div className="tree-selector__leaf__item">
                <div className="tree-selector__leaf__item__content">
                    <div className="checkbox">
                        {!props.disableSelection && <>
                            <input 
                                type="checkbox" 
                                id={"tree-selector__leaf__ck_" + id} 
                                onChange={onChange} 
                                checked={numberOfSelectedNodes > 0}
                            />
                            <label className="checkbox__label" htmlFor={"tree-selector__leaf__ck_" + id}>{label}</label>
                        </>}
                        {props.disableSelection &&
                            <span>{label}</span>
                        }
                        
                    </div>
                </div>
                {(branch != null || props.showInput) && 
                    <>
                        <div className="tree-selector__leaf__item__spacer" onClick={onToggle}></div>
                        <div className="tree-selector__leaf__item__summary" onClick={onToggle}>
                            {(props.showInput && props.inputType != "textarea" && (!(branch != null && props.inputOnlyOnLeafs))) && <div className="tree-selector__leaf__item__input">
                                <input type="text" onChange={onInputChange} value={getInputValue() ?? ""} />
                            </div>}

                            {!props.disableSelection && <>
                                <span>{numberOfSelectedNodes} {M("of")} {numberOfNodes}</span>
                            </>}
                            {branch != null && <a href="#" onClick={onToggle}><i className="zmdi zmdi-caret-down"></i></a>}
                        </div>
                    </>
                }
            </div>            
            {(props.showInput && props.inputType == "textarea" && (!(branch != null && props.inputOnlyOnLeafs))) && <div className="tree-selector__leaf__item__input--textarea">
                <textarea onChange={onInputChange} value={getInputValue() ?? ""} />
            </div>}
            {branch}
        </div>
    )
}

const Branch = props => {
    const idSupplier = props.idSupplier ?? (n => n.id);
    const leafs = props.nodes?.map(n => 
        <Leaf 
            key={idSupplier(n)} 
            node={n} 
            onSelect={props.onSelect}
            onDeselect={props.onDeselect}
            level={props.level}
            idSupplier={props.idSupplier}
            labelSupplier={props.labelSupplier}
            selectedNodes={props.selectedNodes} 
            disableSelection={props.disableSelection}
            showInput={props.showInput}
            inputType={props.inputType}
            inputValues={props.inputValues}
            onInputChange={props.onInputChange}
            disableToggling={props.disableToggling}
            inputOnlyOnLeafs={props.inputOnlyOnLeafs}
        />
    );

    return (
        <div className="tree-selector__branch" data-level={props.level}>
            {leafs}
        </div>
    );
}

export const TreeSelector = props => {
    const root = useRef();
    useEffect(() => {
        if (props.startsCollapsed) {
            $(root.current)
                .find(".tree-selector__leaf")
                .addClass("hidden")
                .find(".tree-selector__branch")
                .data("hidden", true)
                .hide();
        }
    }, [props.nodes]);

    return (
        <div ref={root} className="tree-selector">
            <Branch 
                nodes={props.nodes} 
                onSelect={props.onSelect} 
                onDeselect={props.onDeselect} 
                selectedNodes={props.selectedNodes} 
                level={0} 
                idSupplier={props.idSupplier}
                labelSupplier={props.labelSupplier}
                disableSelection={props.disableSelection}
                showInput={props.showInput}
                inputType={props.inputType}
                inputValues={props.inputValues}
                onInputChange={props.onInputChange}
                disableToggling={props.disableToggling}
                inputOnlyOnLeafs={props.inputOnlyOnLeafs}
            />
        </div>
    )
}